export default "__VITE_ASSET__d96957c9__"